<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
      <i class="fa-regular fa-chevron-left chevron-back-button"></i>
    </ion-button>

    <ion-title> {{'Detalhes do ' | translate}} {{(getNomenclatura(tipoEvento) | nomenclatura | async)}} </ion-title>
  </ion-buttons>
</ion-header>

<ion-content *ngIf="!loaded">
  <app-loading-spinner></app-loading-spinner>
</ion-content>

<ion-content *ngIf="loaded">
  <div class="banner-container">
    <img class="banner-image" [src]="evento.imagem | image:'evento'" />

    <ion-row class="row-chips">
      <ion-col size="9">
        <ion-chip *ngIf="evento.instituicao" class="chip-overlay">
          <i class="fa-thin fa-building-columns"></i>
          <p class="instituicao-nome">
            {{ evento.instituicao.nome }}
          </p>
        </ion-chip>
      </ion-col>
    </ion-row>
  </div>

  <ion-grid class="evento-detalhes">
    <ion-row>
      <ion-col>
        <p class="tema-evento">{{evento.tema}}</p>
      </ion-col>
    </ion-row>

    <ion-row class="dados-principais"
      *ngIf="evento.dataInicio && evento.dataFim || evento.localFisico || evento.formato">
      <ion-col class="aling-ion-col" size="12" *ngIf="evento.dataInicio && evento.dataFim && exibirDataValidade == 0">
        <i class="fa-thin fa-calendar-check"></i>
        <span>{{ evento.dataInicio | dateFormat:'d MMMM' }} — {{ evento.dataFim | dateFormat:'d MMMM' }}</span>
      </ion-col>

      <ion-col class="aling-ion-col" size="12" *ngIf="evento.localFisico">
        <i class="fa-thin fa-location-dot"></i>
        <span>{{ evento.localFisico }}</span>
      </ion-col>

      <ion-col class="aling-ion-col" size="12" *ngIf="evento.localFisico">
        <i class="fa-thin" [ngClass]="{
            'fa-circle-location-arrow': evento.formato == '0',
            'fa-wifi': evento.formato == '1',
            'fa-house-laptop': evento.formato == '2'
          }"></i>
        <span *ngIf="evento.formato == '0'">{{ 'Presencial' | translate }}</span>
        <span *ngIf="evento.formato == '1'">{{ 'Online' | translate }}</span>
        <span *ngIf="evento.formato == '2'">{{ 'Semipresencial' | translate }}</span>
      </ion-col>

      <ion-col class="aling-ion-col" size="12" *ngIf="isOrganizador">
        <i class="fa-thin fa-users-rectangle"></i>

        <span class="date-evento" *ngIf="quantidadeInscritos > 0 else semInscritos">
          {{quantidadeInscritos}} {{textoInscritos}}
        </span>
        <ng-template #semInscritos>
          <span class="date-evento"> {{textoInscritos}} </span>
        </ng-template>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="!evento.isInscrito" class="endereco">
      <ion-col size="12" class="border-endereco">
        <div>
          <div [innerHTML]="spanDecorado"></div>
        </div>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="showEndereco && evento.formato != '1'" class="endereco">
      <ion-col size="12" class="border-endereco">
        <ion-label>
          <h5> {{'Como Chegar' | translate}} </h5>
        </ion-label>

        <span (click)="abrirMapa(evento.endereco)">
          <a> {{evento.endereco | endereco}} </a>
          <br />
        </span>
      </ion-col>

      <ion-col>
        <ion-card class="endereco-maps" (click)="abrirMapa(evento.endereco)">
          <img class="img-row" src="../../../assets/imgs/instituicao/maps.png" />

          <ion-card-content *ngIf="evento.endereco.logradouro">
            <ion-row>
              <ion-col size="12">
                <div>
                  <p class="maps"> {{'Ver no mapa' | translate}} </p>
                </div>
              </ion-col>
            </ion-row>
          </ion-card-content>
        </ion-card>
      </ion-col>
    </ion-row>

    <div class="card-opcoes" *ngIf="organizadores.length > 0 || evento.isAdmin">
      <ion-row>
        <ion-col class="aling-ion-col" *ngIf="organizadores.length > 0" size="10" id="open-modal">
          <i class="fa-thin fa-users-rectangle border-icon"></i>

          <span>{{'Visualizar organizadores' | translate}}</span>
        </ion-col>

        <ion-col class="aling-ion-col aling-chevron" *ngIf="organizadores.length > 0" size="2" id="open-modal">
          <i class="fa-regular fa-chevron-right"></i>
        </ion-col>

        <ion-col class="aling-ion-col" size="10" *ngIf="evento.isAdmin" (click)="addPessoas()">
          <i class="fa-thin fa-user-plus border-icon"></i>

          <span>{{'Inscrever Pessoas' | translate}}</span>
        </ion-col>

        <ion-col class="aling-ion-col aling-chevron" size="2" *ngIf="evento.isAdmin" (click)="addPessoas()">
          <i class="fa-regular fa-chevron-right"></i>
        </ion-col>

        <ion-col class="aling-ion-col" size="10" *ngIf="evento.isAdmin" (click)="calendario(evento)">
          <i class="fa-thin fa-bell-on border-icon"></i>

          <span>{{'Lembre-me' | translate}}</span>
        </ion-col>

        <ion-col class="aling-ion-col aling-chevron" size="2" *ngIf="evento.isAdmin" (click)="calendario(evento)">
          <i class="fa-regular fa-chevron-right"></i>
        </ion-col>
      </ion-row>
    </div>

    <ion-row>
      <ion-col>
        <div [ngStyle]="{'background': getColor('bg')}" *ngIf="layout.length">
          <div *ngFor="let l of layout">
            <div *ngIf="l.tipo == '1'" class="ql-editor">
              <div [ngStyle]="{'color': getColor('text')}" [innerHTML]="l.conteudo"></div>
            </div>

            <ion-card class="card-video" *ngIf="l.tipo == '2'">
              <div class="iframe-container">
                <div>
                  <video-player [id]="l.ordem" [video]="l.conteudo"></video-player>
                </div>
              </div>
            </ion-card>

            <div *ngIf="l.tipo == '3'" class="container-img">
              <img class="conteudo-imagem" [src]="l.conteudo | image:' '" />
            </div>

            <div class="my-4" *ngIf="l.tipo == '4'">
              <div class="conteudo">
                <div [ngStyle]="{'color': getColor('text')}">{{l.conteudo}}</div>
              </div>

              <div *ngFor="let item of evento.encontros" class="item-encontro">
                <div class="tema">
                  <p class="m-title">{{'TEMA' | translate}}</p>

                  <p class="materia">{{item.materia}}</p>
                </div>

                <div class="data">
                  <p class="m-title">{{'DATA E HORA' | translate}}</p>

                  <p class="data-format">
                    {{item.dataInicio | dateFormat:'dd/MM/yyyy HH:mm'}} - {{item.dataFim | dateFormat:'HH:mm'}}
                  </p>
                </div>
              </div>
            </div>

            <div style="background: transparent" *ngIf="l.tipo == '5'">
              <ion-item lines="none" style="--background: transparent !important">
                <ion-avatar slot="start">
                  <img [src]="l.imagem | image:' '" />
                </ion-avatar>
                <ion-label style="align-self: center; font-size: 18px" [ngStyle]="{'color': getColor('text')}">
                  {{l.conteudo}}
                </ion-label>
              </ion-item>
            </div>

            <div *ngIf="l.tipo == '6'">
              <div class="center">
                <span style="font-size: 17px; font-weight: 700; color: black">
                  <div *ngIf="displayTimeEvento" [innerHtml]="displayTimeEvento"></div>
                  <div *ngIf="!displayTimeEvento">{{l.conteudo}}</div>
                </span>
              </div>
            </div>
          </div>
        </div>
      </ion-col>
    </ion-row>
  </ion-grid>

  <ion-grid class="encontro-detalhes" *ngIf="evento.encontros.length > 0">
    <div>
      <div class="prox-event">
        <ion-card-header>
          <div class="data-evento-mes">
            <i class="far fa-calendar icon-title"></i>

            <span class="mes-evento"> {{'Próximos Encontros' | translate}} </span>
          </div>
        </ion-card-header>
      </div>

      <div class="swiper-wrapper-container">
        <ion-row>
          <ion-col size="1" style="display: flex; justify-content: center; align-items: center;"
            *ngIf="evento.encontros.length > 1" (click)="voltarAoPrimeiroSlide()">
            <div>
              <i class="fa-regular fa-chevron-left"></i>
            </div>
          </ion-col>

          <ion-col size="11" style="padding-right: 0px;">
            <swiper-container #swiperEl class="mySwiper swiper-container" slides-per-view="1.2" space-between="10"
              pagination="false">
              <swiper-slide *ngFor="let e of visibleEncontros" class="slide" (click)="openEncontro(e)">
                <ion-card class="card-swiper">
                  <img class="banner-image" [src]="evento.imagem | image:'evento'" alt="Banner do evento"
                    loading="lazy" />

                  <ion-card-content class="conteudo-evento">
                    <div class="data-card" *ngIf="exibirDataValidade == 0">
                      <span class="mes">{{ e.dataInicio | dateFormat:"MMM" | uppercase }}</span>
                      <span class="dia">{{ e.dataInicio | dateFormat:"dd" }}</span>
                      <span class="hora">{{ e.dataInicio | dateFormat:"hora" }}</span>
                    </div>

                    <div class="texto-evento">
                      <ion-card-subtitle class="descricao-evento">
                        <div class="titulo-evento">
                          {{ e?.materia ? e.materia : evento.tema }}
                        </div>

                        <div *ngIf="e.localFisico" class="item-description">
                          <i class="fa-solid fa-location-dot icon"></i>
                          <p class="local" style="text-transform: capitalize; font-weight: 700">
                            {{ e.localFisico }}
                          </p>
                        </div>
                      </ion-card-subtitle>
                    </div>
                  </ion-card-content>
                </ion-card>
              </swiper-slide>

              <swiper-slide *ngIf="evento.encontros.length > 7">
                <div class="swiper-slide-full" (click)="openListEncontros(evento.encontros)">
                  <div class="ver-todos">
                    <div class="ver-todos-icon">
                      <i class="fa-thin fa-calendar-check icon"></i>
                      <span class="ver-todos-span"> {{'VER TODOS' | translate}} </span>
                    </div>
                  </div>
                </div>
              </swiper-slide>
            </swiper-container>
          </ion-col>
        </ion-row>
      </div>
    </div>
  </ion-grid>


  <ion-grid class="encontro-detalhes" *ngIf="encontrosPassados.length > 0">
    <div>
      <div class="prox-event">
        <ion-card-header>
          <div class="data-evento-mes">
            <i class="far fa-calendar icon-title"></i>

            <span class="mes-evento"> {{'Encontros Passados' | translate}} </span>
          </div>
        </ion-card-header>
      </div>

      <div class="swiper-wrapper-container">
        <ion-row>
          <ion-col size="1" style="display: flex; justify-content: center; align-items: center;" *ngIf="encontrosPassados.length > 1">
            <div (click)="voltarPrimeiroSlide()">
              <i class="fa-regular fa-chevron-left"></i>
            </div>
          </ion-col>

          <ion-col size="11" style="padding-right: 0px;">
            <swiper-container #swiperP class="mySwiper swiper-container" slides-per-view="1.2" lazy="true"
              space-between="10" pagination="false">
              <swiper-slide *ngFor="let e of visibleEncontrosPassados" class="slide" (click)="openEncontro(e)">
                <ion-card class="card-swiper">
                  <img class="banner-image" [src]="evento.imagem | image:'evento'" alt="Banner do evento" />

                  <ion-card-content class="conteudo-evento">
                    <div class="data-card" *ngIf="exibirDataValidade == 0">
                      <span class="mes">{{ e.dataInicio | dateFormat:"MMM" | uppercase }}</span>
                      <span class="dia">{{ e.dataInicio | dateFormat:"dd" }}</span>
                      <span class="hora">{{ e.dataInicio | dateFormat:"hora" }}</span>
                    </div>

                    <div class="texto-evento">
                      <ion-card-subtitle class="descricao-evento">
                        <div class="titulo-evento">
                          {{ e?.materia ? e.materia : evento.tema }}
                        </div>

                        <div *ngIf="e.localFisico" class="item-description">
                          <i class="fa-solid fa-location-dot icon"></i>
                          <p class="local" style="text-transform: capitalize; font-weight: 700">{{e.localFisico}}</p>
                        </div>
                      </ion-card-subtitle>
                    </div>
                  </ion-card-content>
                </ion-card>
              </swiper-slide>

              <swiper-slide *ngIf="encontrosPassados.length > 7">
                <div class="swiper-slide-full" (click)="openListEncontros(encontrosPassados)">
                  <div class="ver-todos">
                    <div class="ver-todos-icon">
                      <i class="fa-thin fa-calendar-check icon"></i>
                      <span class="ver-todos-span"> {{'VER TODOS' | translate}} </span>
                    </div>
                  </div>
                </div>
              </swiper-slide>
            </swiper-container>
          </ion-col>
        </ion-row>
      </div>
    </div>
  </ion-grid>

  <!-- Modal Organizadores -->
  <ion-modal trigger="open-modal">
    <ng-template>
      <ion-header class="extendido">
        <ion-buttons>
          <ion-button (click)="closeModal()">
            <i class="fa-regular fa-chevron-left chevron-back-button"></i>
          </ion-button>
          <ion-title>{{'Organizadores' | translate}}</ion-title>
        </ion-buttons>
      </ion-header>

      <ion-content>
        <div class="gradient-extendido"></div>
        <ion-list class="ion-margin" *ngIf="organizadores.length > 0">
          <ion-item *ngFor="let organizador of organizadores" class="ion-margin-top">
            <ion-avatar aria-hidden="true" slot="start">
              <img alt="" [src]="organizador.foto | image:' '" />
            </ion-avatar>
            <ion-label class="nome-organizador">{{organizador.nome}}</ion-label>
          </ion-item>
        </ion-list>

        <sem-registro text="{{'Nenhum organizador localizado' | translate}}"
          *ngIf="organizadores.length == 0"></sem-registro>
      </ion-content>
    </ng-template>
  </ion-modal>
</ion-content>

<ion-footer class="ion-no-border" *ngIf="loaded && evento.hasInscricao == '1' && (!userProvider.isAnonimo() || hasLinkIntegracao)">
  <ion-row>
    <ion-col size="10" *ngIf="!evento.isInscrito && config != 0">
      <ion-button expand="block" class="btn-default" (click)="openLinkExterno()">
        {{'Realizar Inscrição' | translate}}
      </ion-button>
    </ion-col>

    <ion-col size="10" *ngIf="evento.isInscrito">
      <ion-button expand="block" class="btn-default" (click)="openLinkExterno()">
        {{'Detalhes da Inscrição' | translate}}
      </ion-button>
    </ion-col>
  </ion-row>
</ion-footer>